
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface AccountPerformanceFieldProps {
  form: UseFormReturn<any>;
}

const AccountPerformanceField = ({ form }: AccountPerformanceFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="performance_url"
      render={({ field }) => (
        <FormItem>
          <FormLabel htmlFor="performance_url">Performance URL (Optional)</FormLabel>
          <FormControl>
            <Input 
              {...field} 
              id="performance_url"
              name="performance_url"
              placeholder="Enter performance tracking URL" 
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default AccountPerformanceField;
